import { render, staticRenderFns } from "./index.vue?vue&type=template&id=94b89482&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchIcon: require('/usr/src/app/components/icons/search-icon.vue').default,Chevron: require('/usr/src/app/components/account/common-elements/icons/chevron.vue').default,LnCustomButton: require('/usr/src/app/components/ln-custom-button.vue').default})
